import { Card, CardContent, Typography, Box } from '@mui/material';

interface VerdictCardProps {
    verdict: 'take' | 'counter' | 'walk';
    reason: string;
    fairSplit: number;
}

const verdictConfig = {
    take: {
        label: 'Take It',
        color: '#4caf50',
        bg: '#e8f5e9',
    },
    counter: {
        label: 'Counter',
        color: '#ff9800',
        bg: '#fff3e0',
    },
    walk: {
        label: 'Walk Away',
        color: '#f44336',
        bg: '#ffebee',
    },
};

export const VerdictCard = ({ verdict, reason, fairSplit }: VerdictCardProps) => {
    const config = verdictConfig[verdict];

    return (
        <Card sx={{ borderLeft: 6, borderColor: config.color }}>
            <CardContent sx={{ bgcolor: config.bg }}>
                <Box display="flex" alignItems="center" gap={2} mb={1}>
                    <Typography
                        variant="h5"
                        sx={{ color: config.color, fontWeight: 'bold' }}
                    >
                        {config.label}
                    </Typography>
                    {verdict === 'counter' && (
                        <Typography variant="h6" sx={{ color: config.color }}>
                            &mdash; suggest {fairSplit.toFixed(1)}%
                        </Typography>
                    )}
                </Box>
                <Typography variant="body1">{reason}</Typography>
            </CardContent>
        </Card>
    );
};
